module.exports = __webpack_public_path__ + "static/media/JustAct Icons 2-02.ec98e0f1.svg";